import VideoPlayer from "promokit-videoplayer";
import Chtinfo from "./chtinfo";
// import Environment from "./environment";

class Selection {
    constructor(opts) {
        this.opts = $.extend(false, {
            el:"#element",
            chtData:{
                tribe:"human",      // kamael, human, elf, dark, oak, dwarf
                gender:"male",      // male, female
                job:"death",        // death, warrior, wizard
                face:"face0",       // face0, face1, face2
                head1:"shape0",     // shape0, shape1, shape2, shape3, shape4, shape5, shape6
                hair2:"color0",     // color0, color1, color2, color3
            }
        }, opts);

        this.aniKamel = new TimelineMax({paused:true});
        this.aniHuman = new TimelineMax({paused:true});
        this.aniElf = new TimelineMax({paused:true});
        this.aniDark = new TimelineMax({paused:true});
        this.aniOak = new TimelineMax({paused:true});
        this.aniDwarf = new TimelineMax({paused:true});

        this.dataInfo = new Chtinfo();

        this.$el = $(this.opts.el);
        this.$tabWrap = this.$el.find(".sele-tab");
        this.$tabMenu = this.$tabWrap.find("[data-tab-menu]");
        this.$sele = this.$el.find(".sele");
        this.$tabCon = this.$sele.find("[data-tab-con]");

        this.movieArray = [];
        this.readyArray = [];
        this.$objEl = {};
        this.currMovie = "";
        this.prevMovie = "";
        this.currObjMovie = "";
        this.prevObjMovie = "";

        this.prev = {
            tribeId:"",
            genderId:"",
            jobId:""
        };

        this._init();
    };

    _init(){
        this._dataSet();
        this._displaySet();
        this._tabElementSet();
        this._controls();
        this._setAnimation();
    };

    _controls(){
        this.$tabMenu.on("click", (e)=>{
            if(!this.readyArray[this.currMovie]) return false;
            this.tabVisible($(e.currentTarget).data("tab-menu"));
        });

        $("[data-tribe='menu']").on("click", "[data-gender-menu]", (e)=>{
            if(!this.readyArray[this.currMovie]) return false;
            this.genderVisible($(e.currentTarget).data("gender-menu"));
        });

        $("[data-job-wrap]").on("click", "[data-job-menu]", (e)=>{
            if(!this.readyArray[this.currMovie]) return false;
            this.jobVisible($(e.currentTarget).data("job-menu"));
        });
    }

    _dataSet(){
        $.each(this.dataInfo.chtInfo, (objectIdx, objectData)=>{
            this.$tabCon.eq(objectIdx).append(
                "<div class='sele-menu sele-menu__"+objectData.tribe+"'>" +
                    "<ul class='sele-menu__wrap' data-tribe='menu'>"+
                        "<li class='sele-menu__list sele-menu__list--male' data-gender-menu='male'>" +
                            "<button type='button' class='sele-menu__list--btn'>male</button>" +
                        "</li>" +
                        "<li class='sele-menu__list sele-menu__list--female' data-gender-menu='female'>" +
                            "<button type='button' class='sele-menu__list--btn'>female</button>" +
                        "</li>" +
                    "</ul>"+
                "</div>"
            );
            $.each(objectData.property, (genderIdx, genderData)=>{
                this.$tabCon.find(".sele-menu__"+objectData.tribe+"").append(
                    "<ul class='sele-menu__wrap' data-job-wrap='"+genderData.gender+"'></ul>"
                );
                $.each(genderData.job, (jobIdx, jobData)=>{
                    this.$tabCon.find(".sele-menu__"+objectData.tribe+"").find("[data-job-wrap='"+genderData.gender+"']").append(
                        "<li class='sele-menu__list sele-menu__list--"+jobData+"' data-job-menu='"+jobData+"'>" +
                            "<button type='button' class='sele-menu__list--btn'>"+jobData+"</button>" +
                        "</li>"
                    );
                });
            });
        });
    };

    _displaySet(){
        $.each(this.dataInfo.chtInfo, (objectIdx, objectData)=>{
            if(this.opts.chtData.tribe == objectData.tribe){
                this.$objEl.tabMenu = $("[data-tab-menu='"+objectData.tribe+"']");
                this.$objEl.tabCon = $("[data-tab-con='"+objectData.tribe+"']");
                this.$objEl.genderWrap = this.$objEl.tabCon.find("[data-tribe='menu']");
                this.prev.tribeId = objectData.tribe;
                $.each(objectData.property, (genderIdx, genderData)=>{
                    if(this.opts.chtData.gender == genderData.gender){
                        this.$objEl.jobWrap = this.$objEl.tabCon.find("[data-job-wrap='"+genderData.gender+"']");
                        this.$objEl.genderMenu = this.$objEl.genderWrap.find("[data-gender-menu='"+genderData.gender+"']");
                        this.$objEl.movieWrap = this.$objEl.tabCon.find("[data-movie-wrap='"+genderData.gender+"']");
                        this.prev.genderId = genderData.gender;
                        $.each(genderData.job, (jobIdx, jobData)=>{
                            if(this.opts.chtData.job == jobData){
                                this.$objEl.jobMenu = this.$objEl.jobWrap.find("[data-job-menu='"+jobData+"']");
                                this.$objEl.movieList = this.$objEl.movieWrap.find("[data-movie-con='"+jobData+"']");
                                this.prev.jobId = jobData;
                            };
                        });
                    };
                });
            };
        });
    };

    _setAnimation(){
        this.aniKamel
            .from($(".tribe-cht__kamael1"), 1.1, {x:100, alpha:0, ease:Sine.easeOut})
            .from($(".tribe-cht__kamael2"), 1.1, {x:-100, alpha:0, ease:Sine.easeOut}, "-=1.1")
            .from($(".tribe-txt__kamael"), 0.85, {x:70, alpha:0, ease:Sine.easeOut}, "-=0.5")
            .from($(".sele-menu__kamael"), 0.85, {x:-70, alpha:0, ease:Sine.easeOut}, "-=0.85");

        this.aniHuman
            .from($(".tribe-cht__human2"), 1.1, {x:-100, alpha:0, ease:Sine.easeOut}, "-=1.1")
            .from($(".tribe-txt__human"), 0.85, {x:90, alpha:0, ease:Sine.easeOut}, "-=0.5")
            .from($(".sele-menu__human"), 0.85, {x:-70, alpha:0, ease:Sine.easeOut}, "-=0.85");

        this.aniElf
            .from($(".tribe-cht__elf2"), 1.1, {x:-100, alpha:0, ease:Sine.easeOut}, "-=1.1")
            .from($(".tribe-txt__elf"), 0.85, {x:90, alpha:0, ease:Sine.easeOut}, "-=0.5")
            .from($(".sele-menu__elf"), 0.85, {x:-70, alpha:0, ease:Sine.easeOut}, "-=0.85");

        this.aniDark
            .from($(".tribe-cht__dark2"), 1.1, {x:-100, alpha:0, ease:Sine.easeOut}, "-=1.1")
            .from($(".tribe-txt__dark"), 0.85, {x:90, alpha:0, ease:Sine.easeOut}, "-=0.5")
            .from($(".sele-menu__dark"), 0.85, {x:-70, alpha:0, ease:Sine.easeOut}, "-=0.85");

        this.aniOak
            .from($(".tribe-cht__oak1"), 1.1, {x:100, alpha:0, ease:Sine.easeOut})
            .from($(".tribe-cht__oak2"), 1.1, {x:-100, alpha:0, ease:Sine.easeOut}, "-=1.1")
            .from($(".tribe-txt__oak"), 0.85, {x:90, alpha:0, ease:Sine.easeOut}, "-=0.5")
            .from($(".sele-menu__oak"), 0.85, {x:-70, alpha:0, ease:Sine.easeOut}, "-=0.85");

        this.aniDwarf
            .from($(".tribe-cht__dwarf1"), 1.1, {x:100, alpha:0, ease:Sine.easeOut})
            .from($(".tribe-cht__dwarf2"), 1.1, {x:-100, alpha:0, ease:Sine.easeOut}, "-=1.1")
            .from($(".tribe-txt__dwarf"), 0.85, {x:90, alpha:0, ease:Sine.easeOut}, "-=0.5")
            .from($(".sele-menu__dwarf"), 0.85, {x:-70, alpha:0, ease:Sine.easeOut}, "-=0.85");
    }

    chtAnimation(){
        switch (this.opts.chtData.tribe) {
            case "kamael":
                this.aniKamel.seek(0);
                this.aniKamel.play();
                break;
            case "human":
                this.aniHuman.seek(0);
                this.aniHuman.play();
                break;
            case "elf":
                this.aniElf.seek(0);
                this.aniElf.play();
                break;
            case "dark":
                this.aniDark.seek(0);
                this.aniDark.play();
                break;
            case "oak":
                this.aniOak.seek(0);
                this.aniOak.play();
                break;
            case "dwarf":
                this.aniDwarf.seek(0);
                this.aniDwarf.play();
                break;
        }
    }

    _tabElementSet(){
        this.$tabMenu.removeClass("sele-tab__list--on");
        this.$tabCon.removeClass("sele__tribe--on");
        this.$tabCon.find("[data-tribe='menu']").removeClass("sele-menu__wrap--on");
        this.$tabCon.find("[data-gender-menu]").removeClass("sele-menu__list--on");
        this.$tabCon.find("[data-job-wrap]").removeClass("sele-menu__wrap--on");
        this.$tabCon.find("[data-job-menu]").removeClass("sele-menu__list--on");
        this.$tabCon.find("[data-movie-wrap]").removeClass("sele-movie--on");
        this.$tabCon.find("[data-movie-con]").removeClass("sele-movie__player--on");

        this.$objEl.tabMenu.addClass("sele-tab__list--on");
        this.$objEl.tabCon.addClass("sele__tribe--on");
        this.$objEl.genderWrap.addClass("sele-menu__wrap--on");
        this.$objEl.genderMenu.addClass("sele-menu__list--on");
        this.$objEl.jobWrap.addClass("sele-menu__wrap--on");
        this.$objEl.jobMenu.addClass("sele-menu__list--on");
        this.$objEl.movieWrap.addClass("sele-movie--on");
        this.$objEl.movieList.addClass("sele-movie__player--on");
        this.movieVisible();
        this.chtAnimation();
    };

    _genderElementSet(){
        this.$tabCon.find("[data-gender-menu]").removeClass("sele-menu__list--on");
        this.$tabCon.find("[data-job-wrap]").removeClass("sele-menu__wrap--on");
        this.$tabCon.find("[data-job-menu]").removeClass("sele-menu__list--on");
        this.$tabCon.find("[data-movie-wrap]").removeClass("sele-movie--on");
        this.$tabCon.find("[data-movie-con]").removeClass("sele-movie__player--on");

        this.$objEl.genderMenu.addClass("sele-menu__list--on");
        this.$objEl.jobWrap.addClass("sele-menu__wrap--on");
        this.$objEl.jobMenu.addClass("sele-menu__list--on");
        this.$objEl.movieWrap.addClass("sele-movie--on");
        this.$objEl.movieList.addClass("sele-movie__player--on");

        this.$objEl.jobWrap = this.$objEl.tabCon.find("[data-job-wrap='"+this.opts.chtData.gender+"']");
        this.$objEl.movieWrap = this.$objEl.tabCon.find("[data-movie-wrap='"+this.opts.chtData.gender+"']");

        this.opts.chtData.job = this.$objEl.tabCon.find("[data-job-wrap='"+this.opts.chtData.gender+"']").find("[data-job-menu]").eq(0).data("job-menu");

        this.movieVisible();
    };

    _jobElementSet(){
        this.$objEl.jobWrap.find("[data-job-menu]").removeClass("sele-menu__list--on");
        this.$objEl.jobWrap.find("[data-job-menu='"+this.opts.chtData.job+"']").addClass("sele-menu__list--on");

        this.$objEl.movieWrap.find("[data-movie-con]").removeClass("sele-movie__player--on");
        this.$objEl.movieWrap.find("[data-movie-con='"+this.opts.chtData.job+"']").addClass("sele-movie__player--on");

        this.movieVisible();
    };

    tabVisible(thisData){
        if(thisData == this.prev.tribeId) return false;
        $.each(this.dataInfo.chtInfo, (objectIdx, objectData)=>{
            if(thisData == objectData.tribe){
                this.$objEl.tabMenu = $("[data-tab-menu='"+objectData.tribe+"']");
                this.$objEl.tabCon = $("[data-tab-con='"+objectData.tribe+"']");
                this.$objEl.genderWrap = this.$objEl.tabCon.find("[data-tribe='menu']");
                this.$objEl.genderMenu = this.$objEl.genderWrap.find("[data-gender-menu='"+objectData.property[0].gender+"']");
                this.$objEl.jobWrap = this.$objEl.tabCon.find("[data-job-wrap='"+objectData.property[0].gender+"']");
                this.$objEl.jobMenu = this.$objEl.jobWrap.find("[data-job-menu='"+objectData.property[0].job[0]+"']");
                this.$objEl.movieWrap = this.$objEl.tabCon.find("[data-movie-wrap='"+objectData.property[0].gender+"']");
                this.$objEl.movieList = this.$objEl.movieWrap.find("[data-movie-con='"+objectData.property[0].job[0]+"']");

                this.opts.chtData.tribe = objectData.tribe;
                this.opts.chtData.gender = objectData.property[0].gender;
                this.opts.chtData.job = objectData.property[0].job[0];
            };
        });
        this._tabElementSet();
        this.prev.tribeId = this.opts.chtData.tribe;
        this.prev.genderId = this.opts.chtData.gender;
        this.prev.jobId = this.opts.chtData.job;
    };

    genderVisible(thisData){
        if(this.opts.chtData.tribe == this.prev.tribeId && thisData == this.prev.genderId) return false;
        this.opts.chtData.gender = thisData;

        this.$objEl.genderMenu = this.$objEl.genderWrap.find("[data-gender-menu='"+this.opts.chtData.gender+"']");
        this.$objEl.jobWrap = this.$objEl.tabCon.find("[data-job-wrap='"+this.opts.chtData.gender+"']");
        this.$objEl.jobMenu = this.$objEl.tabCon.find("[data-job-wrap='"+this.opts.chtData.gender+"']").find("[data-job-menu]").eq(0);
        this.$objEl.movieWrap = this.$objEl.tabCon.find("[data-movie-wrap='"+this.opts.chtData.gender+"']");
        this.$objEl.movieList = this.$objEl.tabCon.find("[data-movie-wrap='"+this.opts.chtData.gender+"']").find("[data-movie-con]").eq(0);

        this._genderElementSet();
        this.prev.jobId = this.opts.chtData.job;
        this.prev.genderId = thisData;
    };

    jobVisible(thisData){
        if(this.opts.chtData.tribe == this.prev.tribeId && this.opts.chtData.gender == this.prev.genderId && thisData == this.prev.jobId) return false;
        this.opts.chtData.job = thisData;
        this._jobElementSet();
        this.prev.jobId = thisData;
    };

    movieVisible(){
        let movieUrl = `${this.opts.chtData.tribe}-${this.opts.chtData.gender}-${this.opts.chtData.job}`;

        this.currMovie = $("[data-tab-con='"+this.opts.chtData.tribe+"']")
            .find("[data-movie-wrap='"+this.opts.chtData.gender+"']")
            .find("[data-movie-con='"+this.opts.chtData.job+"']").attr("id");
        this.prevMovie = $("[data-tab-con='"+this.prev.tribeId+"']")
            .find("[data-movie-wrap='"+this.prev.genderId+"']")
            .find("[data-movie-con='"+this.prev.jobId+"']").attr("id");

        if(this.movieArray[this.currMovie] == undefined){
            this.movieArray[this.currMovie] = new VideoPlayer({
                el:`#${this.currMovie}`,
                url:`https://vod.plaync.com/lineage2/deathserver/${movieUrl}.mp4`,
                controls:false,
                // poster:"https://op-wstatic.ncsoft.com/promo/lineage2/event/2019/190731_deathknight/img/whoareyou/header-bg.jpg",
                loop:true,
                autoplay:true,
            });
        }else{
            this.movieArray[this.currMovie].play();
        };

        this.movieArray[this.currMovie].on("canplay", ()=>{
            this.readyArray[this.currMovie] = true;
        });

        if(this.currMovie != this.prevMovie) {
            this.prevObjMovie = this.movieArray[this.prevMovie];
            this.prevObjMovie.stop();
        };
    };

    currDate(){
        let data = new Date();
        let year = data.getFullYear();
        let month = data.getMonth();
        let day = data.getDate();
        let minutes = data.getMinutes();
        let seconds = data.getSeconds();
        let dateStr = year+""+month+""+day+""+minutes+""+seconds;
        return dateStr;
    }

}

export default Selection;


// WEBPACK FOOTER //
// ./src/js/whoareyou/selection.js